// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.index-module__container__TlBfF {
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  padding: 1rem;
}
.index-module__flex-container__xEyrC {
  display: flex;
  flex-direction: row;
  gap: 1rem;
  align-items: center;
  justify-content: flex-end;
}
.index-module__span__vWpud {
  display: flex;
  justify-self: center;
  font-style: italic;
  font-size: 10px;
  margin-right: 1rem;
  margin-top: 0.2rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/MasterManagement/ModalComponents/KeyFobAllocationMaster/CustomerClientKeyFobStats/index.module.less"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB","sourcesContent":[".container {\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n  padding: 1rem;\n}\n.flex-container {\n  display: flex;\n  flex-direction: row;\n  gap: 1rem;\n  align-items: center;\n  justify-content: flex-end;\n}\n.span {\n  display: flex;\n  justify-self: center;\n  font-style: italic;\n  font-size: 10px;\n  margin-right: 1rem;\n  margin-top: 0.2rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `index-module__container__TlBfF`,
	"flex-container": `index-module__flex-container__xEyrC`,
	"span": `index-module__span__vWpud`
};
export default ___CSS_LOADER_EXPORT___;
